import React from 'react';

import { Heading } from '~/components/core';
import Button from '~/components/core/Atomic/Buttons/Button';
import CollapsibleWrapper from '~/components/core/Collapsible/CollapsibleWrapper';
import Text from '~/components/core/TextComponents/Text';
import cn from '~/Utils/cn';

const DIGIT_TO_LETTERS: Record<number, string> = {
  2: 'ABC',
  3: 'DEF',
  4: 'GHI',
  5: 'JKL',
  6: 'MNO',
  7: 'PQRS',
  8: 'TUV',
  9: 'WXYZ',
};

const DIAL_PAD_NUMBERS: string[] = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#'];

interface DialPadCollapsableCardProps {
  onClickDigit: (digit: string) => void;
  currentlyClickedDigits: string;
  onClose: () => void;
}

const DialPadCollapsableCard: React.FC<DialPadCollapsableCardProps> = ({
  onClickDigit,
  currentlyClickedDigits,
  onClose,
}) => {
  return (
    <CollapsibleWrapper
      title={
        <Text className="text-blue-600" weight={Text.WEIGHTS.SEMI_BOLD} variant={Text.VARIANTS.SM}>
          CLOSE DIAL PAD
        </Text>
      }
      defaultState={true}
      onCollapse={onClose}
      variant={CollapsibleWrapper.VARIANT.default}
      backgroundColor={CollapsibleWrapper.BACKGROUND_COLOR.WHITE}
      noDivider
      noBorderLine
      summarySectionClassname="flex items-center justify-center text-blue-600 stroke-blue-600 mr-12 pt-12"
      centerCollapsibleSummary
      collapsibleSummaryPosition={CollapsibleWrapper.COLLAPSIBLE_SUMMARY_POSITION.BOTTOM}
      chevronContainerClassName="text-blue-600 p-0 pr-12 mt-2"
    >
      <div className="mx-auto flex h-full max-w-xs flex-col items-center justify-center space-y-12">
        <Heading variant={Heading.TYPES.H4} className={cn(!currentlyClickedDigits && 'hidden', 'text-center text-xl')}>
          {currentlyClickedDigits || 'Place Holder'}
        </Heading>
        <div className="grid grid-cols-3 gap-12">
          {DIAL_PAD_NUMBERS.map((digit) => (
            <div key={digit}>
              <Button
                className="h-[64px] w-[64px] rounded-lg border border-solid border-slate-500 p-12"
                color="primary"
                variant="outlined"
                onClick={() => onClickDigit(digit)}
                fullWidth
              >
                <div className="flex flex-col items-center justify-center">
                  <Text variant={Text.VARIANTS.XL} weight={Text.WEIGHTS.SEMI_BOLD} className="text-blue-600">
                    {digit}
                  </Text>
                  <Text variant={Text.VARIANTS.XS} className="text-blue-600">
                    {DIGIT_TO_LETTERS[parseInt(digit)] || '\u00A0'}
                  </Text>
                </div>
              </Button>
            </div>
          ))}
        </div>
      </div>
    </CollapsibleWrapper>
  );
};

export default DialPadCollapsableCard;
